import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { r as i } from "../internals/require-object-coercible.js";
import { t as s } from "../internals/to-integer-or-infinity.js";
import { t as n } from "../internals/to-string.js";
var o = t("".slice),
  e = Math.max,
  a = Math.min;
r({
  target: "String",
  proto: !0,
  forced: !"".substr || "b" !== "ab".substr(-1)
}, {
  substr: function substr(r, t) {
    var m,
      f,
      u = n(i(this)),
      c = u.length,
      l = s(r);
    return (l === 1 / 0 && (l = 0), l < 0 && (l = e(c + l, 0)), (m = void 0 === t ? c : s(t)) <= 0 || m === 1 / 0) ? "" : (f = a(l + m, c), l >= f ? "" : o(u, l, f));
  }
});